export default __webpack_public_path__ + "static/media/globe-earth.0a5c1dce.svg";